var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.show)?_c('div',{staticClass:"fdd-text-tips"},[_c('span',{staticClass:"text-hide"},[_vm._v(_vm._s(_vm._f("shortStr")(_vm.text,_vm.maxlength)))]),_c('span',{staticClass:"fdd-text-word"},[_vm._v(_vm._s(_vm.text))])]):_c('div',[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }